module.exports = __webpack_public_path__ + "static/media/container_line.f83d2b48.svg";